// Module
var code = `<div class="signature-card">
  <button
    ng-if="!\$ctrl.useIconButton"
    type="button"
    class="btn"
    ng-class="{'btn-success': \$ctrl.isAvailable(), 'btn-default': !\$ctrl.isAvailable()}"
    ng-disabled="!\$ctrl.isAvailable()"
    ng-click="\$ctrl.showSignature()">
    Show signature card
  </button>

  <a ng-if="\$ctrl.useIconButton" class="btn" ng-class="{'btn-success': \$ctrl.isAvailable(), 'btn-default': !\$ctrl.isAvailable()}" ng-click="\$ctrl.showSignature()">
    <i class="icon-pencil icon-white icon-centered"></i>
  </a>

  <zoomable-picture
    ng-if="\$ctrl.signatureType === 'IMAGE' && \$ctrl.showPopup"
    ng-click="\$ctrl.hideSignature()"
    source-url="\$ctrl.signature"
    description="'Signature'">
  </zoomable-picture>

  <pdf-view
    ng-if="\$ctrl.signatureType === 'PDF' && \$ctrl.showPopup"
    ng-click="\$ctrl.hideSignature()"
    source-url="\$ctrl.signature"
    description="'Signature'">
  </pdf-view>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/signature-card/signature-card.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;